module.exports = __webpack_public_path__ + "img/Travel.d9a7c032.webp";